import { soompi } from 'scripts/api/SoompiApi'
import { authRef, googleLogin, facebookLogin, session } from 'scripts/lib/firebase'
import { patch, put } from 'scripts/helpers/Utils'
import Constants from 'scripts/base/Constants'

const replaceImage = (info) => {
  return info.image.replace(/^data:image\/(png);base64,/, '')
}

const cleanData = (responses) => {
  let cleaner = []
  let data
  responses.forEach((response) => {
    data = {}
    data.id = response.id
    data.title = { text: response.title }
    data.images = {header: { url: response.image }}
    data.type = response.type
    data.slug = response.slug
    data.createdAt = response.createdAt
    cleaner.push(data)
    data = null
  })

  return cleaner
}

export default {
  clicked: (state) => {
    return { clicked: true }
  },

  unclick: (state) => {
    return { clicked: false }
  },

  initListingPosts: (state, actions, data) => {
    return {listings: {...data}}
  },

  listingPosts: async (state, actions, params) => {
    const {topicId, pageName, perPage, page, listSort, lang} = params
    const {listings, clicked} = state
    const finalData = []
    const topic = await new Promise((resolve) => {
      let slugName = { 'fanclub': 'fanClub' }
      soompi.setLanguage(lang).getTopic(slugName[pageName] || pageName)({ id: topicId }, { perPage: perPage, page: page, sort: listSort }).promise.then((topic) => {
        resolve(topic)
      })
    })
    const listKey = listSort ? `${topicId}-${listSort}` : topicId
    const posts = (listings[`${listKey}`] && !clicked) ? [...listings[`${listKey}`].posts, ...topic.results] : topic.results
    finalData[listKey] = {topicId, page, posts, pageInfo: topic.pageInfo}
    actions.unclick()
    return { listings: {...listings, ...finalData} }
  },

  listingFeed: async (state, actions, params) => {
    const {sort, perPage, page, lang} = params
    const {listings, clicked} = state
    const finalData = []
    const feed = await new Promise(resolve => {
      soompi.setLanguage(lang).getPostsBy(sort)({ page: page, perPage: perPage }).promise.then((feed) => {
        resolve(feed)
      })
    })
    const posts = (listings[`${sort}`] && !clicked) ? [...listings[`${sort}`].posts, ...feed.results] : feed.results
    finalData[sort] = {topicId: sort, page, posts, pageInfo: feed.pageInfo}
    actions.unclick()
    return { listings: {...listings, ...finalData} }
  },

  authorPosts: async (state, actions, params) => {
    const {topicId, perPage, page, listSort, lang} = params
    const {listings, clicked} = state
    const finalData = []
    const topic = await new Promise((resolve) => {
      soompi.setLanguage(lang).getAuthorPosts({id: topicId}, {perPage, page, sort: listSort}).promise.then((topic) => {
        resolve(topic)
      })
    })
    const listKey = listSort ? `${topicId}-${listSort}` : topicId
    const posts = (listings[`${listKey}`] && !clicked) ? [...listings[`${listKey}`].posts, ...topic.results] : topic.results
    finalData[listKey] = {topicId, page, posts, pageInfo: topic.pageInfo}
    actions.unclick()
    return { listings: {...listings, ...finalData} }
  },

  search: async (state, actions, params) => {
    const { topicId, query, page, listSort, lang, loadMoreType } = params
    const { listings, clicked } = state
    const listKey = listSort ? `${topicId}-${listSort}` : topicId
    const finalData = []
    let { posts, tags, fanClubs } = listings[`${listKey}`]
    finalData[listKey] = (listings[`${listKey}`] && !clicked) ? listings[`${listKey}`] : []

    if (loadMoreType === 'article' || loadMoreType === undefined) {
      const promises = [
        soompi.setLanguage(lang).getSearch(Object.assign({...params}, {filters: 'type:post', page: params.page.article}))
      ]

      const [ postResponse ] = await Promise.all(promises.map(p => p.promise.catch(e => e)))
      const postData = cleanData(postResponse.results)
      posts = (listings[`${listKey}`] && !clicked) ? [...listings[`${listKey}`].posts, ...postData] : postData

      let hasMore = {
        ...finalData[listKey].hasMore,
        article: postResponse.pageInfo.hasNextPage
      }
      finalData[listKey] = { ...finalData[listKey], topicId, query, page, posts, hasMore }
    }

    const isSearchPage = topicId === 'search'
    if (isSearchPage && (loadMoreType === 'fanclub' || loadMoreType === 'tag' || loadMoreType === undefined)) {
      const promises = [
        soompi.setLanguage(lang).getFanClubSearch(Object.assign({...params}, {page: params.page.fanclub})),
        soompi.setLanguage(lang).getTagSearch(Object.assign({...params}, {page: params.page.tag}))
      ]

      const [ fanclubResponse, tagResponse ] = await Promise.all(promises.map(p => p.promise.catch(e => e)))
      const fanClubData = fanclubResponse.results
      const maxTags = 10 * params.page.tag
      const tagData = tagResponse.results.slice(0, maxTags - fanClubData.length)

      fanClubs = (listings[`${listKey}`] && !clicked) ? [...listings[`${listKey}`].fanClubs, ...fanClubData] : fanClubData
      tags = (listings[`${listKey}`] && !clicked) ? [...listings[`${listKey}`].tags, ...tagData] : tagData
      tags = tags.slice(0, maxTags - fanClubs.length)

      let hasMore = {
        ...finalData[listKey].hasMore,
        tag: tagResponse.pageInfo.hasNextPage,
        fanclub: fanclubResponse.pageInfo.hasNextPage
      }
      finalData[listKey] = { ...finalData[listKey], topicId, query, page, fanClubs, tags, hasMore }
    }

    actions.unclick()
    return { listings: {...listings, ...finalData} }
  },

  login: async (state, actions, params) => {
    const provider = params === 'google' ? googleLogin : facebookLogin
    const auth = await new Promise((resolve) => {
      authRef.signInWithPopup(provider).then((res) => {
        resolve(res)
      }).catch(e => {
        if (e.code !== 'auth/popup-closed-by-user') {
          alert(e.message)
        }
        resolve(false)
      })
    })
    const fandomAuth = await session.set(auth)
    const login = fandomAuth.auth === 'OK'
    return {auth: fandomAuth.auth, login, logout: false}
  },

  logout: async (state) => {
    const auth = await session.del()

    if (auth.auth === 'NO') {
      return {auth: 'NO', user: false, logout: true, login: false}
    } else {
      return state
    }
  },

  profile: async () => {
    const info = await session.get()
    return {auth: info.auth, user: Object.assign({...info.user}, {disqus: info.disqus ? info.disqus.SSO : null})}
  },

  nonLoggedInProfile: async () => {
    return {auth: Constants.Auth.NO}
  },

  updateProfile: async (state, actions, params) => {
    const user = {
      displayName: params.user.displayName,
      description: params.user.description
    }
    const update = await new Promise(resolve => {
      patch({
        url: 'users/profile/' + params.id,
        domain: '',
        headers: null,
        params: user
      }).then(({data}) => {
        if (data.update === 'OK' && params.user.hasImageToUpdate) {
          const image = replaceImage(params.user)
          put({
            url: 'users/profileimage/' + params.id,
            domain: '',
            headers: null,
            params: {
              image: image
            }
          }).then(({data}) => {
            resolve(data)
          })
        } else {
          resolve(data)
        }
      })
    })
    const info = await session.get()
    return {user: Object.assign({...info.user}, {...update}, {disqus: info.disqus ? info.disqus.SSO : null})}
  },

  updateCcpaConsent: async (state, actions, params) => {
    const user = {
      ccpaDNSOption: params.user.ccpaDNSOption
    }

    await new Promise(resolve => {
      patch({
        url: 'users/profile/' + params.id,
        domain: '',
        headers: null,
        params: user
      }).then(({data}) => {
        resolve(data)
      })
    })
    const info = await session.get()
    return {user: Object.assign({...info.user}, { isCcpaUpdate: true }, {disqus: info.disqus ? info.disqus.SSO : null})}
  },

  setSection: (state, actions, data) => {
    return {section: data}
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/actions.js